<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.parker-extract.title"></app-title-bar>
<div class="row">
  <app-parker-extract-form class="col"
                          [form]="filterForm"
                          (searchDTOChanged)="searchReports()"></app-parker-extract-form>
</div>
<ng-container *ngIf="(selectedClient || !allowClientSelection) && filterForm.controls.month.value && this.filterForm.controls.parkerId.value">
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [dataSource]="data">
    <e-columns>
      <e-column field="entryDate"
                headerText="{{'i18n.domain.reports.parker-extract.grid.entryDate' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="exitDate"
                headerText="{{'i18n.domain.reports.parker-extract.grid.exitDate' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="isVisitorParking"
                headerText="{{'i18n.domain.reports.parker-extract.grid.visitorParking' | translate}}">
        <ng-template #template let-data>
          {{(data.isVisitorParking? 'i18n.shared.yes' : 'i18n.shared.no') | translate}}
        </ng-template>      
      </e-column>
      <e-column field="durationInMinutes"
                headerText="{{'i18n.domain.reports.parker-extract.grid.durationInMinutes' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{formatTime(data.durationInMinutes) + 'h'}}
        </ng-template>
      </e-column>
      <e-column field="knownTag.identificationCode"
                headerText="{{'i18n.domain.reports.parker-extract.grid.tagId' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="zone.name"
                headerText="{{'i18n.domain.reports.parker-extract.grid.zone' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="subscriptionName"
                headerText="{{'i18n.domain.reports.parker-extract.grid.subscription' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="amount"
                headerText="{{'i18n.domain.reports.parker-extract.grid.amount' | translate}}"
                clipMode="EllipsisWithTooltip"
                textAlign="right">
        <ng-template #template
                     let-data>
          {{data.amount | number : '1.2-2'}}
        </ng-template>
      </e-column>
      <e-column field="currency"
                headerText="{{'i18n.domain.reports.parker-extract.grid.currency' | translate}}"
                clipMode="EllipsisWithTooltip"
                width="100"
                textAlign="right">
        <ng-template #template
                     let-data>
          {{formatCurrency(data.currency) | translate}}
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
  <div class="mt-3" *ngIf="summaryData?.subscriptionSummary?.length > 0">
    <h5>{{'i18n.domain.reports.parker-extract.subscriptionSummary' | translate}}</h5>
    <ejs-grid
      #subscriptionInfo
      class="grid-with-footer"
      width="100%"
      rowHeight="38"
      [allowPaging]="false"
      [pageSettings]="pageSettings"
      [dataSource]="summaryData?.subscriptionSummary">
      <e-columns>
        <e-column field="subscriptionName"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.subscription' | translate}}"
                  clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.dateRange' | translate}}"
                  clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.appliedStartDate | date : 'dd.MM.yyyy'}} - {{data.appliedEndDate | date : 'dd.MM.yyyy'}}
          </ng-template>
        </e-column>
        <e-column field="feeFromParkingSessions"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.parkingFees' | translate}}"
                  width="120"
                  [customAttributes]="{class: 'reduced-emphasize'}"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{(data.feeFromParkingSessions ?? 0) | number : '1.2-2'}}
          </ng-template>
        </e-column>
        <e-column field="cap"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.capAmount' | translate}}"
                  width="100"
                  [customAttributes]="{class: 'reduced-emphasize'}"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{ !data.cap ? '-' : (data.cap | number : '1.2-2')}}
          </ng-template>
        </e-column>
        <e-column headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.totalParking' | translate}}"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{ (data.totalParkingWithCap ?? 0) | number : '1.2-2'}}
          </ng-template>
        </e-column>
        <e-column field="fixedFee"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.fixAmount' | translate}}"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{(data.fixedFee ?? 0) | number : '1.2-2'}}
          </ng-template>
        </e-column>
        <e-column field="amount"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.amount' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  width="120"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{data.chargedAmount | number : '1.2-2'}}
          </ng-template>
        </e-column>
        <e-column field="currency"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.currency' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  width="100">
          <ng-template #template
                      let-data>
            {{formatCurrency(data.currency) | translate}}
          </ng-template>
        </e-column>
        <e-column field="currencyConversionFactor"
                  headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.conversionRate' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  width="120"
                  textAlign="right">
          <ng-template #template
                        let-data>
            {{data.currencyConversionFactor | number : '1.5-5'}}
          </ng-template>
        </e-column>
        <e-column headerText="{{'i18n.domain.reports.parker-extract.subscriptionSummaryGrid.amount' | translate}} {{summaryCurrency | translate}}"
                  clipMode="EllipsisWithTooltip"
                  textAlign="right">
          <ng-template #template
                      let-data>
            {{(data.convertedChargedAmount ?? data.chargedAmount) | number : '1.2-2'}} {{formatCurrency(data.convertedCurrency) | translate}}
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>

  <app-reports-footer (saveClicked)="saveReport($event)">
    <div right class="amount-display w-100" *ngIf="summaryData">
      <div class="row">
        <div class="col-lg-9 col-6 d-flex justify-content-lg-end">{{'i18n.domain.reports.parker-extract.chargedAmount' | translate}}:</div>
        <div class="col-lg-3 col-6 d-flex justify-content-end align-items-end">{{summaryData.chargedAmount | number : '1.2-2'}} {{summaryCurrency | translate}}</div>
      </div>
    </div>

  </app-reports-footer>
</ng-container>
